import React from 'react'
import Sidebar from '../../containers/SidebarContainer'
import PrivateVerificationLayout from '../PrivateVerificationLayout/PrivateVerificationLayout.js'
import HeaderUser from '../../containers/HeaderUserContainer'
import StatusBar from '../../containers/StatusBarContainer'
import MainTabBarContainer from '../../containers/MainTabBarContainer'

// Import Scss
import './UserLayout.scss'

/**
 * @extends PrivateVerificationLayout
 * @see https://simonsmith.io/reusing-layouts-in-react-router-4/
 */
const UserLayout = ({component: Component, ...rest}) => (
  <PrivateVerificationLayout {...rest} component={matchProps =>
    <div className="user-layout">
      <HeaderUser/>
      <div className="user-layout__inner row">
        <div className="sidebar-container d-none d-lg-block pr-lg-0">
          <Sidebar {...matchProps}/>
        </div>
        <div className="main-container pl-lg-0">
          <div className="candidates-wrapper">
            <div className="candidates__header">
              <MainTabBarContainer />
            </div>
            <div className="candidates__inner">
              <StatusBar />
              <Component {...matchProps}/>
            </div>
          </div>
        </div>
      </div>
    </div>
  } />
)

export default UserLayout



// WEBPACK FOOTER //
// ./src/layouts/UserLayout/UserLayout.js